export default "/images/vendor/flag-icon-css/flags/4x3/tz.svg?42ec1dd14b99f59fe0f2a72b7f591ecd";